import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';
import { UsuarioUnidadeNegocio } from './usuario-unidade-negocio';
import { UnidadeNegocio, unidadeNegocioAtiva, UnidadeNegocioFilter, UnidadeNegocioCrudHttpService, UnidadeNegocioPopulaModalComponent } from '../../unidade-negocio';

@Component({
    selector: 'sgt-usuario-unidade-negocio',
    templateUrl: './usuario-unidade-negocio.component.html',
    styleUrls: ['./usuario-unidade-negocio.component.less']
})
export class UsuarioUnidadeNegocioComponent implements BaseFormList<UsuarioUnidadeNegocio>, OnInit {
    @Input() nomeUsuario = '';
    @Input() entities: UsuarioUnidadeNegocio[];

    unidadesNegocios: UnidadeNegocio[];
    @ViewChild('unidadeNegocioPopulaModal') unidadeNegocioPopulaModal: UnidadeNegocioPopulaModalComponent;

    @ViewChildren('selectUnidadeNegocio') selectsUnidadesNegocios: QueryList<ElementRef>;

    constructor(private messageService: MessageService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService) { }

    ngOnInit() {
        this.searchUnidadesNegocios();
    }

    /** Pesquisa as unidades de negócios ativas */
    private searchUnidadesNegocios() {
        this.unidadesNegocios = [];

        const filter = new UnidadeNegocioFilter();
        filter.situacao = unidadeNegocioAtiva.id;
        this.unidadeNegocioCrudHttpService.searchWithFilter(filter)
            .subscribe(
                entities => this.unidadesNegocios = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as unidades de negócios cadastradas', error)
            );
    }

    /** Obtem a unidade de negócio informada o array de unidades de negócios */
    private getUnidadeNegocio(idUnidadeNegocio: number): UnidadeNegocio {
        for (let j = 0; j < this.unidadesNegocios?.length; j++) {
            const unidadeNegocio = this.unidadesNegocios[j];
            if (unidadeNegocio.id === idUnidadeNegocio) {
                return unidadeNegocio;
            }
        }

        return null;
    }

    /** Ao alterar a unidade de negócio */
    onChangeUnidadeNegocio(entity: UsuarioUnidadeNegocio, idUnidadeNegocio: number) {
        if (!entity) {
            return;
        }

        entity.idUnidadeNegocio = idUnidadeNegocio;
        entity.unidadeNegocio = this.getUnidadeNegocio(idUnidadeNegocio);
    }

    insert() {
        const entity = new UsuarioUnidadeNegocio();
        this.entities.push(entity);

        setTimeout(() => this.setFocusSelectUnidadeNegocio(), 200);
    }

    /** Seta o foco no select da unidade de negócio ao inserir */
    private setFocusSelectUnidadeNegocio() {
        if (!this.selectsUnidadesNegocios) {
            return;
        }
        // Obtendo o último select para setar o foco
        const selectElement = this.selectsUnidadesNegocios.last;
        if (selectElement) {
            jQuery(selectElement.nativeElement).focus();
        }
    }

    delete(index: number) {
        if (index > -1) {
            const entity = this.entities[index];
            this.messageService.confirm(`Deseja realmente excluir a unidade de negócio ${entity?.unidadeNegocio?.nome} do usuário?`).then(result => {
                if (result) {
                    this.entities.splice(index, 1);
                }
            });
        }
    }

    /** Verifica as unidades de negócios estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idUnidadeNegocio) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.idUnidadeNegocio && entityFilter.idUnidadeNegocio === entity.idUnidadeNegocio).length;
            if (count > 1) {
                const nomeUnidadeNegocio = entity?.unidadeNegocio?.nome ?? '';
                this.messageService.info(`A unidade de negócio ${nomeUnidadeNegocio} já está adicionada. Remova ou altere a unidade de negócio duplicada`, 'Não é possível adicionar duas unidades de negócios iguais');
                return false;
            }
        }
        return true;
    }


    /** Resolve as unidades de negócios presentes no usuário */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o ID da unidade de negócio informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idUnidadeNegocio) {
                this.entities.splice(i, 1);
            }
        }
    }

    /** Abre o modal para popular as unidades de negócios */
    openUnidadeNegocioPopulaModal() {
        this.unidadeNegocioPopulaModal.open();
    }

    /** Obtem o sub-título para o modal de popular as unidades de negócios */
    getSubtitleUnidadeNegocioPopulaModal(): string {
        return `Selecione as unidades de negócios que o usuário ${this.nomeUsuario} deve ter acesso e visibilidade`;
    }

    /** Ao adicionar as unidades de negócios através do modal de popula */
    onAdicionarUnidadesNegocios(unidadesNegocios: UnidadeNegocio[]) {
        unidadesNegocios?.forEach(unidadeNegocio => {
            const entity = new UsuarioUnidadeNegocio();
            entity.idUnidadeNegocio = unidadeNegocio.id;
            entity.unidadeNegocio = unidadeNegocio;

            this.entities.push(entity);
        });
    }
}
